import { useQuery } from 'react-query';
import { getBettieChatRoomPictures } from '../../services/bettieProfileService';

export function useGetBettieChatRoomPictures(chatRoomId: string) {
  return useQuery(
    ['bettieChatRoomPictures', chatRoomId],
    () => getBettieChatRoomPictures(chatRoomId),
    {
      enabled: !!chatRoomId
    }
  );
}
